<div>
	<div class="kamona-input-form-container">
		<div class="display-flex relative" style="height: 56px">
			<div [ngClass]="{'flex items-center justify-center':!input?.prefix}"
				 class="mobile-prefix-container {{addPhoneNumberPrefixClass()}}"
				 [class.prefix-has-error]="canShowError()"
				 style="{{input?.prefix ? 'width:18.48%': 'width:24.48%'}}">
				<ng-container *ngIf="input?.prefix else defaultPrefix">
					<div [ngClass]="{'m-[5px]':validInput ||canShowError()}"
						 class="text-[13px] text-black/[.7] m-[3px] ml-4 font-normal not-italic leading-4">
						{{input?.prefix}}
					</div>
				</ng-container>
				<ng-template #defaultPrefix>
					<div>
						<div nz-row nzAlign="middle" nzJustify="center">
							<div style="position:relative;top:.02em">
								<svg fill="none" height="12" viewBox="0 0 16 12" width="16"
									 xmlns="http://www.w3.org/2000/svg">
									<path d="M10.6668 0H5.3335V12H10.6668V0Z" fill="white"/>
									<path
										d="M15.9998 11.3333C15.9998 11.7017 15.7015 12 15.3332 12H10.6665V0H15.3332C15.7015 0 15.9998 0.298333 15.9998 0.666667V11.3333Z"
										fill="#078754"/>
									<path
										d="M5.33333 12H0.666667C0.298333 12 0 11.7017 0 11.3333V0.666667C0 0.298333 0.298333 0 0.666667 0H5.33333V12Z"
										fill="#078754"/>
								</svg>
							</div>
							<div>
								<div class="mobile-prefix">+234</div>
							</div>
						</div>
					</div>
				</ng-template>
			</div>
			<div class="input-form" style="{{input?.prefix ? 'width:81.52%': 'width:75.52%'}}">
				<div class="custom-input-wrapper">
					<input (blur)="setPhoneNumberOnFocus(false)"
						   (focus)="setPhoneNumberOnFocus(true)"
						   (keyup)="onChangeInput($event)"
						   [(ngModel)]="inputValue"
						   [maxlength]="maxInputLength"
						   [ngClass]="{'in-valid':canShowError(), 'valid':validInput}"
						   [placeholder]="placeHolder"
						   id="{{id}}"
						   style="border-top-left-radius:0;border-bottom-left-radius:0" type="text"/>
					<label (click)="onFocus()" for="{{id}}">{{label}}</label>
				</div>
			</div>
			<div *ngIf="isShowInputStateSuffix" [ngClass]="{'kamona-input-suffix':isShowInputStateSuffix}">
				<span *ngIf="canShowError()">
					<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
					<circle cx="12" cy="12" fill="white" r="8"/>
					<path
						d="M12 22C9.34711 22.0024 6.80218 20.9496 4.9263 19.0737C3.05042 17.1978 1.99762 14.6529 2 12V11.8C2.08179 7.79221 4.5478 4.22015 8.26637 2.72305C11.9849 1.22596 16.2381 2.09289 19.074 4.92599C21.9365 7.78607 22.7932 12.0893 21.2443 15.8276C19.6955 19.5659 16.0465 22.0024 12 22ZM12 13.41L14.59 16L16 14.59L13.41 12L16 9.40999L14.59 7.99999L12 10.59L9.41001 7.99999L8.00001 9.40999L10.59 12L8.00001 14.59L9.41001 16L12 13.411V13.41Z"
						fill="#E94444"/>
				</svg>
				</span>
				<span *ngIf="((!input.isError && input?.validate()) && !input?.isLoading())">
					<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
						<circle cx="11.5" cy="11.5" fill="white" r="7.5"/>
						<path
							d="M12 22C6.47967 21.9939 2.00606 17.5203 2 12V11.8C2.10993 6.30452 6.63459 1.92794 12.1307 2.00087C17.6268 2.07379 22.0337 6.56887 21.9978 12.0653C21.9619 17.5618 17.4966 21.9989 12 22ZM8.11568 12.2929C7.72572 11.9045 7.09489 11.9051 6.70568 12.2943C6.31595 12.684 6.31595 13.3159 6.70568 13.7057L8.92064 15.9206C9.51675 16.5167 10.4832 16.5167 11.0794 15.9206L17.295 9.70499C17.6848 9.31523 17.6859 8.68364 17.2975 8.2925C16.9072 7.8994 16.2717 7.89827 15.88 8.28999L10.2303 13.9396C10.1031 14.0669 9.89674 14.0671 9.76921 13.9401L8.11568 12.2929Z"
							fill="#1EB12D"/>
					</svg>
				</span>
				<div *ngIf="input?.isLoading()">
					<div class="kamona-input-loading-panel">
						<div class="loader"></div>
					</div>
				</div>
			</div>
		</div>

		<div class="flex items-center justify-between">
			<div *ngIf="canShowError()" class="error-message">
				{{input?.getErrorMessage()}}
			</div>
			<div *ngIf="input.showCharCount"
				 [ngClass]="{'text-state-error w-fit': canShowError(), 'text-black/20 w-full': !canShowError()}"
				 class="text-right text-xs leading-none text-black/20 mt-1 font-semibold">
				{{input.input?.length || 0}}/{{input.maxLength}}
			</div>
		</div>
	</div>
</div>
